export enum ArtCategory {
    Movie = 'movie',
    Music = 'music',
    Book = 'book',
    Art = 'art',
    Game = 'game',
    PerformingArt = 'performing-art',
}

export type Creator = {
    id: string;
    name: string;
    birthYear: number;
    activityStartYear: number;
    activityEndYear: number;
}

export interface IArt {
    id: string;
    title: string;
    imageUrl: string;
    creatorName: string;
    creator: Creator;
    medium: string;
    year: number;
    country: string;
    language: string;
    actors: string;
    genre: string;
    description: string;
    imdbId: string;
    category: ArtCategory;
}

export interface IArtFindRequest {
    id?: string;
    imdbId?: string;
}